import useTranslatableFlow from 'FlowBuilder/hooks/useTranslatableFlow';
import './MultipleChoice.scoped.scss'
import Radio from 'Shared/components/Radio'

export default function MultipleChoice({ answers, response, setResponse, name, disabled = false, className = '' }) {
  const isDashboard = useSel(s => !!s.dashboard?.id)
  
  const handleChange = (event) => {
    if (event.target.checked) {
      setResponse(+event.target.value);
    }
  }

  if (isDashboard) {
    return (
      <div className={`answers dashboard-dropdown ${className}`}>
        <select 
          value={response ?? ''} 
          onChange={(e) => setResponse(e.target.value === "" ? null : +e.target.value)}
          disabled={disabled}
          className="multiple-choice-dropdown"
        >
          <option value="">-- Select an option --</option>
          {answers.filter(answer => answer.active).map((answer) => (
            <MultipleChoiceDropdownOption
              answer={answer}
              key={answer.id}
            />
          ))}
        </select>
      </div>
    )
  }

  return (
    <div className={`answers ${className}`}>
      {answers.filter(answer => answer.active).map((answer) => (
        <MultipleChoiceAnswer
          answer={answer}
          handleChange={handleChange}
          disabled={disabled}
          response={response}
          key={answer.id}
        />
      ))}
    </div>
  )
}

function MultipleChoiceAnswer({ answer, handleChange, disabled, response }) {
  const { answer: answerTranslated } = useTranslatableFlow({ textContent: answer.textContent })

  return (
    <Radio
      value={answer.id}
      onChange={handleChange}
      disabled={disabled}
      checked={+response === answer.id}
      label={answerTranslated ?? answer.answer}
      key={answer.digitOrder}
    />
  )
}

function MultipleChoiceDropdownOption({ answer }) {
  const { answer: answerTranslated } = useTranslatableFlow({ textContent: answer.textContent })

  return (
    <option value={answer.id}>
      {answerTranslated ?? answer.answer}
    </option>
  )
}
